import {Component, EventEmitter, Input, Output} from "@angular/core";
import {OrderEvents, OrderInitiationStatus} from "../../order/order-events";
import {GroupOrderModel} from "../../group-order/group-order.model";
import {SessionModel} from "../../orchestration/session.model";
import {PaymentType} from "../payment";
import {PaymentEvents} from "../payment-events";
import {PaymentModel} from "../payment.model";

@Component({
    selector: "woa-quick-pay-panel",
    templateUrl: "quick-pay-panel.component.html"
})

export class QuickPayPanelComponent {
    @Input() showSpinner: boolean = false;
    @Input() disabled: boolean = false;
    @Input() applePayType: "plain" | "check-out" = "plain";
    @Input() googlePayType: "plain" | "checkout" = "plain";

    @Output() pay: EventEmitter<PaymentType> = new EventEmitter();

    OrderEvents = OrderEvents;
    PaymentEvents = PaymentEvents;
    PaymentType = PaymentType;
    OrderInitiationStatus = OrderInitiationStatus;

    constructor(public paymentModel: PaymentModel,
                public sessionModel: SessionModel,
                public groupOrderModel: GroupOrderModel) {
    }
}



// WEBPACK FOOTER //
// ./src/app/payment/quick-pay-panel/quick-pay-panel.component.ts